import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { LanguageSwitcherComponent } from './language-switcher.component';

@NgModule({
    declarations: [LanguageSwitcherComponent],
    imports: [
        CommonModule,
        TranslateModule,
        NgbDropdownModule,
    ],
    exports: [LanguageSwitcherComponent],
})
export class LanguageSwitcherModule {}